import { useEffect, useState } from "react";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import DealCard from "@/components/DealCard";
import { deals as dApi } from "@/lib/api";
import { useStateCtx } from "@/context/StateContext";
import { Flame, Tag } from "lucide-react";

export default function Deals() {
  const { stateCode } = useStateCtx();
  const [deals, setDeals] = useState([]);
  const [tab, setTab] = useState("all");

  useEffect(() => {
    const sp = stateCode === "ALL" ? undefined : stateCode;
    dApi.list({ state: sp }).then(setDeals);
  }, [stateCode]);

  const flash = deals.filter((d) => d.is_flash);
  const standard = deals.filter((d) => !d.is_flash);
  const list = tab === "flash" ? flash : tab === "standard" ? standard : deals;

  return (
    <div className="min-h-screen relative overflow-hidden">
      <div className="blob" style={{ width: 380, height: 380, background: "#FF1A8C", top: -120, right: -80 }} />
      <div className="blob" style={{ width: 280, height: 280, background: "#FFE74C", bottom: 0, left: -60, animationDelay: "-8s" }} />
      <NavBar />
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-12 relative">
        <span className="sticker sticker-magenta mb-4 inline-block"><Flame size={11} strokeWidth={2.4} /> Live deals · {stateCode}</span>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[0.92] mt-3 mb-3">
          <span className="text-rainbow">Flash</span> drops.<br />Real timers.
        </h1>
        <p className="text-lg text-[#0B0F0C]/65 max-w-2xl mb-8">Verified by the shop. Auto-pause when wallet hits zero. Claim → walk in → done.</p>

        <div className="flex gap-2 mb-8 flex-wrap">
          {[
            { k: "all", l: "All", n: deals.length },
            { k: "flash", l: "Flash", n: flash.length, icon: <Flame size={12} strokeWidth={2.4} /> },
            { k: "standard", l: "Standard", n: standard.length, icon: <Tag size={12} strokeWidth={2.4} /> },
          ].map((t) => (
            <button key={t.k} data-testid={`deals-tab-${t.k}`} onClick={() => setTab(t.k)}
              className={`btn-x ${tab === t.k ? "btn-primary" : "btn-ghost"} !py-2 !px-4 !text-xs`}>
              {t.icon} {t.l} ({t.n})
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((d, i) => <DealCard key={d.id} d={d} idx={i} />)}
          {list.length === 0 && (
            <div className="col-span-full card-x p-12 text-center bg-[#FAF6E8]">
              <div className="text-5xl mb-2">🪦</div>
              <div className="font-display text-3xl font-extrabold mb-1">No live drops.</div>
              <div className="text-sm text-[#0B0F0C]/60">Check back in a sec, or switch state.</div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
